import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "settings-vertical",
  "use": "settings-vertical-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"settings-vertical\"><path d=\"M7 18.13V2H5v16.13a4 4 0 000 7.74V30h2v-4.13a4 4 0 000-7.74zm0 5.6A2 2 0 118 22a2 2 0 01-1 1.73zM17 6.13V2h-2v4.13a4 4 0 000 7.74V30h2V13.87a4 4 0 000-7.74zm0 5.6A2 2 0 1118 10a2 2 0 01-1 1.73zM27 14.13V2h-2v12.13a4 4 0 000 7.74V30h2v-8.13a4 4 0 000-7.74zm0 5.6A2 2 0 1128 18a2 2 0 01-1 1.73z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/settings-vertical.svg
// module id = dv0d
// module chunks = 39 44